import eventService from '../api/event'

const state = {
    events: [],
    anarchiveEvents: [],
    page: 1,
    last_page: null,
    allIsLoad: false,
    selectedEvent: null,
    selectedSubCategory: null,
}

const getters = {
    getAllSelectedEventImages: state => {
        const medias = state.selectedEvent ? state.selectedEvent.images : []
        const images = []

        for (const media of medias) {
            for (const file of media.files) {
                images.push({
                    id: file.id,
                    title: media.title,
                    credits: media.credits,
                    description: media.description,
                    url: file.cached_url,
                })
            }
        }

        return images
    },

    upcomingEvents: state => {
        const currentDate = new Date();

        return state.events
            .filter(event => {
                const eventDate = new Date(event.finishing_date);
                return eventDate >= currentDate;
            })
            .sort((a, b) => new Date(a.starting_date) - new Date(b.starting_date));
    },

    getFilteredAnarchiveEvents: state => {
        return state.selectedSubCategory ?
            state.anarchiveEvents.filter(anarchiveEvent => anarchiveEvent.subcategories.some(subcategory => subcategory.id === state.selectedSubCategory.id)) :
            state.anarchiveEvents;
    }
}

const actions = {
    getLimitYear () {
        return eventService.limitYear().then(response => response.data)
    },

    search({commit, state}, {query, page = null, paginationSize = null}) {
        return eventService.search(query, page, paginationSize).then(response => {
            const result = response.data

            return result.data ? result.data : result
        }, () => false)
    },

    getEvent({commit, state, dispatch}, eventId) {
        const requestId = 'GET_EVENT_' + eventId
        commit('title/resetTitle', '', {root: true})
        commit('setSelectedEvent', null)
        commit('ui/enableLoader', requestId, {root: true})

        return eventService.find(eventId ? eventId : state.selectedEvent.id).then(response => {
            const event = response.data
            commit('setSelectedEvent', event)
            commit('title/updateTitle', event.name, {root: true})
            return event
        }, () => false).finally(() => commit('ui/disableLoader', requestId, {root: true}))
    },

    getEvents ({commit, state}) {
        return eventService.all(state.page).then(response => {
            const result = response.data
            const events = result.data ? result.data : result

            if (state.page === state.last_page){
                commit('allIsLoaded')
            }

            if (state.page === 1){
                commit('setLastPage', response.data.last_page)
                commit('setEvents', events)
            }else {
                commit('addEvents', events)
            }

            return events
        }, () => false)
    },

    loadMore ({commit, state, dispatch}) {
        if (state.page < state.last_page){
            commit('incrementPage')
            dispatch('getEvents')
        }
    },

    getForYear ({commit, state}, {startYear, endYear}) {
        commit('ui/enableLoader', 'ANARCHIVE_EVENTS', {root: true});
        return eventService.forYear(startYear, endYear).then(response => {
            const result = response.data
            const events = result.data ? result.data : result

            if (events.length){
                commit('setAnarchiveEvents', events)
            }

            return events
        }, () => false).finally(() => commit('ui/disableLoader', 'ANARCHIVE_EVENTS', {root: true}));
    },

    getRandom () {
        return eventService.random().then(response => response.data)
    },

    getRandoms ({commit, state}, limit) {
        return eventService.randoms(limit).then(response => response.data)
    }
}

const mutations = {
    setSelectedEvent(state, event) {
        state.selectedEvent = event
    },
    addEvents(state, newEvents) {
        const uniqueEventIds = new Set(state.events.map(event => event.id));
        const uniqueNewEvents = newEvents.filter(event => !uniqueEventIds.has(event.id));
        state.events = state.events.concat(uniqueNewEvents);
    },
    setEvents(state, events) {
        state.events = events
    },
    setAnarchiveEvents(state, events) {
        state.anarchiveEvents = events
    },
    setLastPage(state, lastPage){
        state.last_page = lastPage
    },
    incrementPage(state){
        state.page += 1
    },
    allIsLoaded(state){
        state.allIsLoad = true
    },
    setSelectedSubCategory(state, selectedSubCategory) {
        state.selectedSubCategory = selectedSubCategory;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
